export class DynamicDateRange {
  relation: 'last' | 'this' | 'next';
  unit: 'week' | 'month' | 'quarter' | 'year';

  static STRING_REGEX = /^DYNAMIC_DATE_RANGE\[(last|this|next)_(week|month|quarter|year)(:\d)?\]$/;

  constructor(relation, unit) {
    this.relation = relation;
    this.unit = unit;
  }

  static parse(value: string): DynamicDateRange {
    if (!DynamicDateRange.STRING_REGEX.test(value)) {
      return null;
    }
    const match = value.match(DynamicDateRange.STRING_REGEX);
    return new DynamicDateRange(match[1], match[2]);
  }

  toString(first_day_of_week: string): string {
    first_day_of_week = first_day_of_week || '';
    let unit = this.unit === 'week' && first_day_of_week  !== '' ? `${this.unit}:${first_day_of_week}` : this.unit;
    return `DYNAMIC_DATE_RANGE[${this.relation}_${unit}]`;
  }
}
